import React from 'react'
import { Element } from './'

export const Row = props => {
    const { element } = props;

    return (
        <div className={"row" + (element.className ? " " + element.className : "")}>
            { element && element.elements && element.elements.map((e, eindex) => <Element key={eindex} {...props} element={e}></Element>) } 
        </div>
    )
}